import { ReactElement, MouseEventHandler, useEffect, useState } from "react";
import { IconButton, Select, MenuItem, TextField, InputAdornment } from "@mui/material";
import { FlexGrid, Button } from "@albo-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";

interface CustomSearchBarProps {
    onConfirm: (value: object) => void;
    field?: boolean;
    textField?: string;
    defaultField?: any;
    button?: object;
    select?: object;
    refresh?: boolean;
    refreshType2?: boolean;
    auto?: boolean;
    onHandleAuto?: Function;
    startAdornment?: ReactElement;
    enableSearch?: boolean;
    onClickCaptureHandler?: MouseEventHandler<HTMLDivElement>;
}

const CustomSearchBar: React.FC<CustomSearchBarProps> = ({onConfirm, field, textField, defaultField, button, select, refresh, refreshType2, auto, onHandleAuto, startAdornment, enableSearch, onClickCaptureHandler}) => {
    const [clearSearch, setClearSearch] = useState(false);
    const [codeCountry, setCodeCountry] = useState("52");
    const [form, setForm] = useState({});
    const [nameType, setNameType] = useState({gname: "", lname: "", slname: ""});
    const values = [
        { key: "gname", label: "Nombre" },
        { key: "lname", label: "Apellido paterno" },
        { key: "slname", label: "Apellido materno" },
    ];
    
    const clearInput = () => {
        setForm(JSON.parse(JSON.stringify({})));
        setClearSearch(false);
        setCodeCountry("52");
        if (select && (select["default"] || select["default2"])) {
            let f = {};
            f["type"] = select["default"];
            setForm(JSON.parse(JSON.stringify(f)));
        }
    };

    const changePhoneLada = (e) => {
        setCodeCountry(e.target.value);
    };

    const onHandleChange = (e) => {
        let value = e.target.value;
        let f = form;
        f["value"] = value.trim();
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onHandleType = (key, e) => {
        let value = e.target.value;
        let f = form;

        if (key === "type" && value === "name") {
            f["value"] = "";
        }
        if (key === "type" && typeof f["value"] === "object") {
            f["value"] = "";
        }

        f[key] = value;
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const changeNameValue = (key, e) => {
        let n = nameType;
        let f = form;

        n[key] = e.target.value;
        setNameType(n);

        f["value"] = n;
        setForm(JSON.parse(JSON.stringify(f)));
    };

    const onHandleConfirm = () => {
        setClearSearch(true);
        return onConfirm(form);
    };

    const onHandleRefresh = () => {
        clearInput();
        return onConfirm({});
    };

    const presDown = (e) => {
        if (e.key === "Enter") {
            setClearSearch(true);
            return onConfirm(form);
        }
    };

    useEffect(() => {
        if (select && (select["default"] || select["default2"])) {
            let f = form;
            f["type"] = select["default"];
            setForm(JSON.parse(JSON.stringify(f)));
        }
        if (select && select["default2"]) {
            let f = form;
            f["filter"] = select["default2"];
            setForm(JSON.parse(JSON.stringify(f)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [select]);

    useEffect(() => {
        auto && form["type"] !== "name" && onHandleAuto(form);
        auto && form["value"] && setClearSearch(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form]);

    useEffect(() => {
        let f = form;
        if (defaultField && select && select["default"] === "name"){
            let n = nameType;
            n = defaultField;
            setNameType(JSON.parse(JSON.stringify(n)));
        } else if (defaultField){
            f["value"] = defaultField;
        }
        select && select["default"] && (f["type"] = select["default"] || "");
        setForm(JSON.parse(JSON.stringify(f)));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultField]);

    return (
        <FlexGrid container spacing={1} fullWidth justify="flex-end">
            { select && select["options2"] && select["options2"].length > 0 &&
                <Select value={form["filter"]  || -1} onChange={onHandleType.bind(this, "filter")} size='small' color='secondary' style={{height: "52px", width: 250, backgroundColor: "#ffffff"}}>
                    <MenuItem value={-1} disabled>{select["text2"] || "Seleccione"}</MenuItem>
                    {select["options2"].map((item) => {
                        return <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>
                    })}
                </Select>
            }
            { select && select["options"] && select["options"].length > 0 && 
                <Select value={form["type"] || -1} onChange={onHandleType.bind(this, "type")} disabled={select["disabled"]} size='small' color='secondary' style={{height: "52px", width: 'auto', backgroundColor: "#ffffff"}}>
                    {!select["hideDefault"] && <MenuItem value={-1} disabled>{select["text"] || "Seleccione"}</MenuItem>}
                    {select["options"].map((item) => {
                        return <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>
                    })}
                </Select>
            }
            { field && form["type"] !== "name" && <TextField id="textField_1" name="textField_1" placeholder={textField || 'Buscar...'} value={form["value"] || ""} onPaste={onHandleChange.bind(this)} onChange={onHandleChange.bind(this)} color='secondary' fullWidth
                onKeyDown={presDown}
                onClickCapture={onClickCaptureHandler}
                InputProps={{
                    style: {backgroundColor: "#ffffff" }, sx: {"& input:hover":{border: "none !important"} },
                    endAdornment: (
                        clearSearch && !enableSearch ? (
                            <IconButton onClick={clearInput.bind(this)}>
                                <ClearIcon />
                            </IconButton>
                        ) : (
                            <IconButton disabled={enableSearch ? false : (select && select["options"]) ? !(form["type"] && form["value"]) : !form["value"]} onClick={onHandleConfirm}>
                                <SearchIcon />
                            </IconButton>
                        )
                    ),
                    startAdornment: (
                        <InputAdornment position="start">
                            <>
                                {startAdornment && startAdornment}
                                {form["type"] === "phone" && select["catalogs"] ? (
                                    <Select variant='standard' value={codeCountry} onChange={changePhoneLada} displayEmpty
                                    renderValue={(selected) => `+${selected}`}>
                                        { select["catalogs"].country.map((item, index) => (
                                            <MenuItem key={`state-${index}`} value={item.m[0].dial}>
                                                (+{item.m[0].dial}) {item.m[0].code2}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                ) : null}
                            </>
                        </InputAdornment>
                    )
                }}
            />
            }
            { field && form["type"] === "name" && 
                values.map((value, index) => (
                    <TextField
                        key={index}
                        value={form[value.key] || nameType[value.key]}
                        placeholder={value.label}
                        onChange={changeNameValue.bind(this, value.key)}
                        onKeyDown={presDown}
                        variant="outlined"
                        InputProps={{
                            style: {backgroundColor: "#ffffff" },
                            endAdornment: index === 2 && (
                                clearSearch ? (
                                    <IconButton onClick={clearInput.bind(this)}>
                                        <ClearIcon />
                                    </IconButton>
                                ) : (
                                    <IconButton disabled={enableSearch ? false : (select && select["options"]) ? !(form["type"] && form["value"]) : !form["value"]} onClick={onHandleConfirm}>
                                        <SearchIcon />
                                    </IconButton>
                                )
                            )
                        }}
                    />
                ))
            }

            { refresh && <IconButton title="Recargar" onClick={onHandleRefresh.bind(this)} sx={{padding: "0 !important", height: "52px"}}>
                {!refreshType2 ? <RefreshIcon sx={{padding: 1, borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179", height: "-webkit-fill-available" }}/>
                : <RefreshIcon sx={{padding: 1, boxSizing: "content-box", height: "-webkit-fill-available", boxShadow: "0px 2px 7px #EDF0F4", border: "1px solid #3743AA41", color: "#3743aa" }}/>}
            </IconButton>}
            
            { button && <Button onClick={button["onHandle"].bind(this)} buttonType='secondary' size='large' style={{ height: "52px", width: button["width"] || "auto" }} >{button["text"]}</Button>}
        </FlexGrid>
    );
};

export default CustomSearchBar;
